function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetCurrentAccount, setAccountId, setBypassAuthentication } from "../modules";
var useAppSelector = useSelector;
var useAppDispatch = function() {
    return useDispatch();
};
export var useAuth = function() {
    var dispatch = useAppDispatch();
    var _useAppSelector = useAppSelector(function(param) {
        var auth = param.auth;
        return auth;
    }), accountId = _useAppSelector.accountId, bypassAuthentication = _useAppSelector.bypassAuthentication;
    var saveAccountId = useCallback(function(accountId) {
        return dispatch(setAccountId(accountId));
    }, [
        dispatch
    ]);
    var shouldValidateAuthentication = useCallback(function(shouldValidate) {
        return dispatch(setBypassAuthentication(shouldValidate));
    }, [
        dispatch
    ]);
    var logout = useCallback(function() {
        localStorage.removeItem("vch.auth");
        dispatch(setAccountId());
        dispatch(resetCurrentAccount());
    }, [
        dispatch
    ]);
    var getBasicAuthValue = useCallback(function(accountId, accountSecret) {
        if (accountId && accountSecret) {
            var key = globalThis.btoa("".concat(accountId, ":").concat(encodeURIComponent(accountSecret).replaceAll(/%([0-9A-F]{2})/g, function(_, p1) {
                return String.fromCodePoint(Number.parseInt(p1, 16));
            })));
            return "Basic ".concat(key);
        }
    }, []);
    var getBasicAuthHeader = useCallback(function(accountSecret) {
        var basicAuth = getBasicAuthValue(accountId, accountSecret);
        if (basicAuth) {
            return _define_property({}, "X-Neru-Basic-Auth", basicAuth);
        }
    }, [
        accountId,
        getBasicAuthValue
    ]);
    var _ref;
    return {
        accountId: (_ref = accountId !== null && accountId !== void 0 ? accountId : localStorage.getItem("vch.account_id")) !== null && _ref !== void 0 ? _ref : undefined,
        getBasicAuthHeader: getBasicAuthHeader,
        logout: logout,
        saveAccountId: saveAccountId,
        shouldValidateAuthentication: shouldValidateAuthentication,
        skipAuth: bypassAuthentication
    };
};

//# sourceMappingURL=useAuth.js.map